<template>
  <div class="flex flex-column gap-2">
    <span class="text-500 text-sm">
      Choose what appears on the widget's end screen when a snippet finishes
      playing.
    </span>
    <div class="flex gap-3">
      <div
        class="cta-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'cta-option-active': modelValue === 'want_more' }"
        @click="$emit('update:modelValue', 'want_more')"
      >
        <RadioButton
          inputId="ctaModeWantMore"
          :modelValue="modelValue"
          value="want_more"
          name="ctaMode"
          @update:modelValue="$emit('update:modelValue', $event)"
        />
        <label for="ctaModeWantMore" class="cursor-pointer">Want More?</label>
      </div>
      <div
        class="cta-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'cta-option-active': modelValue === 'listener_apps' }"
        @click="$emit('update:modelValue', 'listener_apps')"
      >
        <RadioButton
          inputId="ctaModeListenerApps"
          :modelValue="modelValue"
          value="listener_apps"
          name="ctaMode"
          @update:modelValue="$emit('update:modelValue', $event)"
        />
        <label for="ctaModeListenerApps" class="cursor-pointer"
          >Listener Apps</label
        >
      </div>
    </div>
    <Message severity="info" :closable="false">{{
      MODE_DESCRIPTIONS[modelValue]
    }}</Message>
  </div>
</template>

<script setup>
import RadioButton from "primevue/radiobutton";
import Message from "primevue/message";

defineProps({
  modelValue: {
    type: String,
    default: "want_more",
  },
});
defineEmits(["update:modelValue"]);

const MODE_DESCRIPTIONS = {
  want_more: `In this mode we show a "Want More?" button that opens the full episode.`,
  listener_apps: `In this mode we show icons linking to the show's Spotify, Apple, and RSS.`,
};
</script>

<style scoped>
.cta-option {
  border: 1px solid var(--surface-border);
  transition: all 0.15s ease;
}

.cta-option:hover {
  border-color: var(--primary-color);
}

.cta-option-active {
  border-color: var(--primary-color);
  background: rgba(99, 102, 241, 0.08);
}
</style>
